import initialState from './initialState'
import { SET_CONFIGURATION } from '../constants/actionTypes'


export default (state = initialState, action) => {
    switch (action.type) {
        case SET_CONFIGURATION:
            return {
                ...state,
                ...action.config
            }

        default:
            return state
    }
}
